import { supabase } from '@/lib/supabase';
import { telegramService } from './telegramService';

interface ContactSubmissionData {
  name: string;
  company: string;
  email: string;
  phone: string;
  country: string;
  message: string;
  interest: string;
}

export const contactService = {
  async createContactSubmission(data: ContactSubmissionData) {
    const { error } = await supabase
      .from('contact_submissions')
      .insert({
        name: data.name,
        company: data.company,
        email: data.email,
        phone: data.phone,
        country: data.country,
        message: data.message,
        interest: data.interest,
        status: 'pending'
      });

    if (error) {
      throw new Error(error.message);
    }

    // Send Telegram notification immediately after successful submission
    try {
      await telegramService.sendLeadAlert({
        leadSource: 'Contact Form',
        country: data.country,
        company: data.company,
        contactName: data.name,
        email: data.email,
        phone: data.phone,
        message: `Interest: ${data.interest}\n\n${data.message}`,
      });
    } catch (telegramError) {
      // Log but don't fail the submission if Telegram notification fails
      console.error('Failed to send Telegram notification:', telegramError);
    }

    return { success: true };
  },

  async getAllSubmissions() {
    const { data, error } = await supabase
      .from('contact_submissions')
      .select('*')
      .order('created_at', { ascending: false });

    if (error) {
      throw new Error(error.message);
    }

    return data || [];
  },

  async updateStatus(id: string, status: string) {
    const { error } = await supabase
      .from('contact_submissions')
      .update({ status, updated_at: new Date().toISOString() })
      .eq('id', id);

    if (error) {
      throw new Error(error.message);
    }

    return { success: true };
  }
};